import { Suspense } from "react";
import PageSpinner from "../components/BodyElements/SpinnerBlock/PageSpinner";

const LazyComponent = (props) => {
  return <Suspense fallback={<PageSpinner />}>{props.item}</Suspense>;
};

export default LazyComponent;
